// extracted by mini-css-extract-plugin
module.exports = {"title":"Header_title__3t31D"};